import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { DeleteDoctor, editDoctors, fetchDocotrsList, getCountries, getSpeciality, getSpecialityName } from '../reduxactions/suprivisoractions/SupDoctorsActions';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { LoginService } from '../services/LoginService';
import { SUPRIVISOR_API } from '../ApiNames';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';

export const SuprivisorDoctor = () => {
  interface SpecialType {
    Id: string; // Change the type accordingly
    SpecilityName: string; // Change the type accordingly
  }
  const uid = window.sessionStorage.getItem('uid');
  const usertype = window.sessionStorage.getItem('usertype');

  const [globalFilter, setGlobalFilter] = useState('');
  console.log("GLOBALFILTER", globalFilter)

  const data = useSelector((state: RootState) => state.sdoctorss.data);
  const countrydatas = useSelector((state: RootState) => state.sdoctorss.country);
  const specialitysss = useSelector((state: RootState) => state.sdoctorss.special);
  const names = useSelector((state: RootState) => state.sdoctorss.name);





  const dispatch = useDispatch();

  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchDocotrsList(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const FetchSpeciality = async () => {
    try {
      await dispatch(getSpeciality(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const FetchCountryData = async () => {
    try {
      await dispatch(getCountries() as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffectOnce(() => {
    fetchDataAsync();
    FetchSpeciality();
    FetchCountryData();

  }, [dispatch]);

  //   //add data

  const [FirstName, setFname] = useState('');
  const [LastName, setLname] = useState('');
  const [Email, setEmail] = useState('');
  const [Phone, setPhone] = useState('');
  const [CountryID, setCountry] = useState('');
  const [SpecilityName, setSpeciality] = useState('');
  const [SpecialID, setSpecialID] = useState<SpecialType | null>(null);

  const [addDilog, setaddDilog] = useState(false);
  const msgs = useRef(null);
  const toast = useRef<Toast>(null);

  const addDataAsync = async () => {
    try {
      const payload = { fname: FirstName, lname: LastName, email: Email, phone: Phone, country: CountryID, specid: SpecilityName, uid: uid, q: 2 };
      const apiname = SUPRIVISOR_API.sdoctorget;
      const response = await LoginService.getData(apiname, payload);
      if (response === "Doctor added Successfully") {
        if (toast.current) {
          toast.current.show({ severity: 'success', detail: response });
        }
      } else {
        if (toast.current) {
          toast.current.show({ severity: 'info', detail: response });
        }
      }
      fetchDataAsync();
      setaddDilog(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const close = () => {
    setaddDilog(false);
    setDoctoredit(false);
    setDeleteConfirmation(false);
  };
  //edit data
  const [doctoredit, setDoctoredit] = useState(false);
  const [editData, setEditData] = useState({
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    CountryID: '',
    SpecilityName: '',
    DoctorID: '',
  });
  const toast1 = useRef<Toast>(null);

  const Editdata = (rowData: any) => {
    setEditData({
      FirstName: rowData.FirstName,
      LastName: rowData.LastName,
      Email: rowData.Email,
      Phone: rowData.Phone,
      CountryID: rowData.CountryID,
      SpecilityName: rowData.SpecilityID,
      DoctorID: rowData.DoctorID,
    });
    setDoctoredit(true);
  }


  const EditcontestRules = async () => {
    const { FirstName, LastName, Email, Phone, CountryID, SpecilityName, DoctorID } = editData;
    try {
      const response = await dispatch(editDoctors(FirstName, LastName, Email, Phone, CountryID, SpecilityName, DoctorID, uid) as any);
      if (toast1.current) {
        toast1.current.show({ severity: 'success', detail: response, summary: 'Updated Successfully' });
      }
      fetchDataAsync();
      setDoctoredit(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };



  //Delete code
  const removedata = useSelector((state: RootState) => state.sdoctorss.remove);
  const toast4 = useRef(removedata);
  const [delData, setDeleteData] = useState({
    DoctorID: '',
  });

  const [deleteConfirmation, setDeleteConfirmation] = useState(false);

  const Delete = (rowData: any) => {

    setDeleteData({
      DoctorID: rowData.DoctorID,
    });
    setDeleteConfirmation(true);
  };

  const toast2 = useRef<Toast>(null);

  const confirmDelete = async () => {
    const { DoctorID } = delData;
    try {
      const data = await dispatch(DeleteDoctor(DoctorID) as any);
      if (toast2.current) {
        toast2.current.show({ severity: 'error', detail: data, summary: 'Deleted Successfully' });
      }
      fetchDataAsync();
      setDeleteConfirmation(false);
    } catch (error) {
      console.error('Error deleting data:', error);
    }
  };

  const navigate = useNavigate();
  const viewPage = (rowData: any) => {
    const url = `/viewdoctors/${rowData.DoctorID}`;
    console.log('rowdata:', rowData.DoctorID)
    navigate(url);
  }
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/sup-doctors.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div style={{ marginLeft: '220px' }}>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="grid mb-2">
              <div className="col-6">
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="card-header p-2" style={{ marginTop: '50px' }}>
                <h2>Doctors List</h2>
              </div>
              <div className="col-16" style={{ textAlign: "right" }}>
                <a
                  title="help"
                  onClick={(e) => openWindow(e, IUrl)}
                  style={{

                    color: "blue",
                    fontSize: 15, cursor: "pointer"
                  }}
                >Help for this Page &nbsp;
                  <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                </a>
              </div>
              <br></br>
              <div className="card flex flex-wrap justify-content-end">
                <Button label="Add Doctors" severity="info" onClick={() => setaddDilog(true)} style={{ marginRight: '80px' }} />

              </div>
              <div className="box box-primary">
                <div className="card">
                  <p className="m-0">
                    <div>
                      <div className="card flex flex-wrap justify-content">
                        <span className="p-input-icon-left">
                          <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                          <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                        </span>
                      </div>
                      <DataTable value={data} tableStyle={{ minWidth: '50rem' }}
                        filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                        globalFilterFields={['FirstName', 'LastName', 'SpecilityName', 'Email']}>
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>

                        <Column body={(rowData) => `${rowData.FirstName} ${rowData.LastName}`} sortable header="Doctor Name"></Column>
                        <Column field="SpecilityName" sortable header="Speciality "></Column>
                        <Column field="Email" sortable header="Email "></Column>
                        <Column header="Option" body={(rowData) => (

                          <div className="options-buttons" style={{ marginLeft: '-30px' }}>
                            <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-3" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => viewPage(rowData)} />
                            <Button rounded outlined className='mr-3' tooltip="Edit" icon="pi pi-pencil" style={{ backgroundColor: 'white', color: 'seagreen', width: '2rem', height: '2rem' }} onClick={() => Editdata(rowData)} />
                            <Button icon="pi pi-trash" rounded outlined tooltip="Delete" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'red', width: '2rem', height: '2rem' }} onClick={() => Delete(rowData)} />
                          </div>
                        )}></Column>
                      </DataTable>

                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Dialog header="Add Doctors" visible={addDilog} style={{ width: '32vw', height: '65vh' }} onHide={() => setaddDilog(false)} >
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">First Name:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" style={{ width: '18vw' }} name="Contest Name" placeholder='Enter FirstName ' onChange={(e) => setFname(e.target.value)} />
          </div>
        </div>
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">Last Name:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" style={{ width: '18vw' }} name="Contest Name" placeholder='Enter FirstName ' onChange={(e) => setLname(e.target.value)} />
          </div>
        </div>

        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">Email:</label>
          </div>
          <div className="col-6" >
            <InputText id="amount" style={{ width: '18vw' }} name="amount" placeholder='Enter Email' onChange={(e) => setEmail(e.target.value)} />
          </div>
        </div>

        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label"> Phone:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" type="tel" style={{ width: '18vw' }} value={Phone} placeholder='Enter Phone' onChange={(e) => { const value = e.target.value; if (/^\d{0,10}$/.test(value)) { setPhone(value); } }} />
          </div>
        </div>
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label"> Country:</label>
          </div>
          <div className="col-6" >
            <Dropdown
              id="country"
              value={CountryID}
              onChange={(e: DropdownChangeEvent) => setCountry(e.value)}
              options={countrydatas}
              optionLabel="name"
              optionValue="countryids"
              placeholder="Select a Country"
              className="custom-dropdown-placeholder"
              style={{ width: '18vw' }}
            />
          </div>
        </div>
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label"> Speciality:</label>
          </div>
          <div className="col-6" >
            <Dropdown
              id="speciality"
              value={SpecilityName}
              onChange={(e: DropdownChangeEvent) => setSpeciality(e.value)}
              options={specialitysss}
              optionLabel="SpecilityName"
              optionValue="SpecilityID"
              placeholder="Select a Speciality"
              className="custom-dropdown-placeholder"
              style={{ width: '18vw' }}
            />
          </div>
        </div>
        <Button label="Close" onClick={close} style={{ marginTop: '10px' }} severity="secondary" />
        <Button label="Add" onClick={addDataAsync} style={{ float: 'right', marginTop: '10px' }} />
      </Dialog >
      <Dialog header="Edit Doctors" visible={doctoredit} style={{ width: '35vw', height: '70vh' }} onHide={() => setDoctoredit(false)} >
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">First Name:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" name="fname" onChange={(e) => setEditData({ ...editData, FirstName: e.target.value })} value={editData.FirstName} style={{ width: '18vw' }} disabled />
          </div>
        </div>
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">Last Name:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" style={{ width: '18vw' }} name="fname" onChange={(e) => setEditData({ ...editData, LastName: e.target.value })} value={editData.LastName} disabled />
          </div>
        </div>

        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">Email:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" style={{ width: '18vw' }} name="fname" onChange={(e) => setEditData({ ...editData, Email: e.target.value })} value={editData.Email} disabled />
          </div>
        </div>

        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label"> Phone:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" style={{ width: '18vw' }} name="fname" maxLength={10} onChange={(e) => { const value = e.target.value.replace(/\D/g, ''); if (value.length <= 10) { setEditData({ ...editData, Phone: value }); } }} value={editData.Phone} />
          </div>
        </div>
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label"> Country:</label>
          </div>
          <div className="col-6" >
            <Dropdown
              id="country"
              value={editData.CountryID}
              onChange={(e: DropdownChangeEvent) => setCountry(e.value)}
              options={countrydatas}
              optionLabel="name"
              optionValue="countryids"
              placeholder="Select a Country"
              className="custom-dropdown-placeholder"
              style={{ width: '18vw' }}
            />
          </div>
        </div>
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label"> Speciality:</label>
          </div>
          <div className="col-6" >
            <Dropdown
              id="speciality"
              value={editData.SpecilityName}
              onChange={(e: DropdownChangeEvent) => setEditData({ ...editData, SpecilityName: e.target.value })}
              options={specialitysss}
              optionLabel="SpecilityName"
              optionValue="SpecilityID"
              placeholder="Select a Speciality"
              className="custom-dropdown-placeholder"
              style={{ width: '18vw' }}
            />
          </div>
        </div>
        <Button label="Close" onClick={close} severity="secondary" style={{ marginTop: '10px' }} />
        <Button label="Update" onClick={EditcontestRules} style={{ float: 'right', marginTop: '10px' }} />
      </Dialog >
      < Dialog header="Confirm Delete" style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
        <div>Are you really want to Remove...?</div>
        <br></br>
        <Button label="Delete" icon="pi pi-check" className='mr-3 p-button-raised' onClick={confirmDelete} />
        <Button label="Close" icon="pi pi-times" onClick={close} className="mr-3 p-button-secondary" />
      </Dialog >





      <Toast ref={toast} ></Toast>
      <Toast ref={toast1} ></Toast>
      <Toast ref={toast2} ></Toast>
    </div>
  )
}